import React from 'react';
import { Link } from 'react-router-dom';

const Fostering = () => {
  return (
    <div className="fostering-container">
      <div className="image-section" data-aos="fade-down">
        <img
          src="/img/blog/checkups.png"
          alt="Lipaworld and Checkups logos"
          className="community-image"
        />
      </div>
      <div className="content-section" data-aos="fade-right">
        <div className="category-and-title">
          <div className="metadata">
            <span className="category">Press Release</span>
            <span className="separator">•</span>
            <span className="read-time">10min read</span>
            <span className="separator">•</span>
            <span className="date">September 30, 2024</span>
          </div>
          <h2 className="title">Lipaworld partners with CheckUps to unlock healthcare benefits for families of Kenyans back at home</h2>
        </div>
        <p className="description">
        The innovative partnership offers secure remittances and inclusive healthcare benefits to families in Kenya, bridging the gap between...
        </p>
        <div className="author-section">
          {/* <img
            src="/img/blog/rev1.png"
            alt="Lipaworld"
            className="avatar"
          /> */}
          <span className="author-name">Lipaworld</span>
        </div>
        <Link to='/blog/Lipaworld-partners-with-CheckUps' className="read-more-button"> <button className="read-more-button">Read more</button></Link>
      </div>
    </div>
  );
};

export default Fostering;
